
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';

const { shoppingGiveBackMerchant, shoppingGiveBackRequest } = api;

@Component({
  components: { DateRange },
})
export default class ShoppingGiveBackRequestList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private loading = false;

  private panel = 0;

  private headers = [
    { text: '會員ID', value: 'userIdPublic' },
    { text: '合作廠商', value: 'merchantName' },
    { text: '訂單編號', value: 'orderNo' },
    { text: '訂單金額', value: 'amount' },
    { text: '登記日期', value: 'createdOn' },
  ];

  private merchants: Array<{ text: string; value: string }> = [];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    merchantId: this.$route.query.merchantId || undefined,
    userIdPublic: this.$route.query.userIdPublic || undefined,
    orderNo: this.$route.query.orderNo || undefined,
    startDate: this.$route.query.startDate || undefined,
    endDate: this.$route.query.endDate || undefined,
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      merchantId: undefined,
      userIdPublic: undefined,
      orderNo: undefined,
      startDate: undefined,
      endDate: undefined,
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async exportCsv() {
    this.loading = true;
    const { status, data } = (await shoppingGiveBackRequest.export(this.filter)) || {};
    this.loading = false;
    if (status === 0) return;
    Util.saveFile(data, '登記回饋用戶.txt');
  }

  private async requestMerchants() {
    const { data: { data } } = (await shoppingGiveBackMerchant.list({ pageNo: 1 })) || {};
    if (!!data) {
      const merchants: Array<{ text: string; value: string }> = data.map(
        (v: any) => ({ text: v.name, value: v.id }),
      );
      this.merchants = [{ text: '全部', value: '' }, ...merchants];
    }
  }

  private async requestData() {
    this.loading = true;
    const { data } = await shoppingGiveBackRequest.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: ShoppingGiveBackRequestList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestMerchants();
      await vm.requestData();
    });
  }
}
